import { SbuDto } from './../_models/sbu.models';

import axios, { AxiosResponse } from 'axios';
import {CreateFactoryPayloadStructure} from "../_models/app.models";

const getFactoryList = (userEmail: string): Promise<AxiosResponse<SbuDto[]>> => {
    return axios.get('/api/v1/factories', {params: {userEmail}});
}

const createFactory = (payload: CreateFactoryPayloadStructure) => {
    return axios.put('/api/v1/factories', payload)
}

const getModulesByFactory = (factoryId: number) => {
    return axios.get('/api/v1/modules/GetModulesByFactory', {params: {factoryId}})
}

const getModulesByFactoryCode = (factoryCode: string) => {
    return axios.get('/api/v1/modules', {params: {factoryCode : factoryCode,effectiveDate : new Date().toLocaleDateString("en")}})
}

export const factoryService = {
    getFactoryList,
    createFactory,
    getModulesByFactory,
    getModulesByFactoryCode
}
